import classNames from 'classnames'
import type {ReactElement} from 'react'

import EntityPath from '../../../containers/EntityPath'
import {getBuild} from '../../../selectors'
import type {BuildId, BuildTypeId} from '../../../types'
import type {BuildPathOwnProps} from '../BuildPath/BuildPath.types'
import BuildStatus from '../BuildStatus/BuildStatus.container'

import styles from './BuildPathAndStatus.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = BuildPathOwnProps & {
  buildId?: BuildId | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
  withIcon?: boolean
  className?: string
  entityPathClassName?: string
  buildStatusClassName?: string
}

function BuildPathAndStatus({
  buildId,
  buildTypeId,
  withIcon,
  className,
  entityPathClassName,
  buildStatusClassName,
  ...pathProps
}: Props): ReactElement {
  const resolvedBuildTypeId = useAppSelector(
    state => buildTypeId ?? getBuild(state, buildId)?.buildType,
  )

  return (
    <div className={classNames(styles.buildPath, className)}>
      <EntityPath
        buildTypeId={resolvedBuildTypeId}
        projectOrBuildTypeNode={{
          nodeType: 'all',
        }}
        className={entityPathClassName}
        {...pathProps}
      />
      {buildId != null && (
        <>
          <span className={styles.separator}>{'\u00a0/\u00a0'}</span>
          <BuildStatus
            className={buildStatusClassName}
            buildId={buildId}
            withIcon={withIcon}
            useNumber
          />
        </>
      )}
    </div>
  )
}

export default BuildPathAndStatus
